export default "__VITE_ASSET__FLoestp2__"